/*
  This is working and can be testing on the axios example page.
  To be fully functional the cookie service and root store need to be working.
 */
import get from 'lodash/get'
import env from '~/libs/env'
import { embeddedErrorRouting } from '~/libs/embedded'
import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'

function handle401 ({ config, error, cookies, userStore, rootStore, route }) {
  const conditionalRouteStrings = ['/account-connection/', 'financial-integration-service', 'user/logout'];
  const oktaCheck = rootStore.oktaId
  const tokenCheck = get(config, 'headers.common.Authorization', null) !== userStore.unauthorizedToken

  const isMobile = process.client && cookies.get('isMobile') && window.flutter_inappwebview
  if (isMobile) {
    window.flutter_inappwebview.callHandler('tokenHandler')
    return Promise.reject(error)
  }

  const isEmbeddedCookie = process.client && cookies.get('isEmbedded')
  const isEmbeddedUser = get(rootStore, 'authUser.isEmbedded')
  const isEmbeddedRoute = get(window, 'location.pathname', '').includes('embedded');

  const is401RouteApproved = conditionalRouteStrings
    .some(str => get(error, 'response.config.url').includes(str));

  const isEmbeddedCheck = isEmbeddedUser || isEmbeddedCookie || isEmbeddedRoute
  const errorMessage = get(error, 'response.data.errors[0].message')
  const errorObj = {
    location: 'AXIOS_HANDLER',
    status: 401,
    isEmbedded: isEmbeddedCheck,
    oktaCheck: !!oktaCheck,
    errorMessage,
    tokenCheck,
  }
  log.warning('AUTHENTICATION FAILURE:' + JSON.stringify(errorObj))
  if (isEmbeddedCheck) {
    window.vueRouter.push(embeddedErrorRouting(401))
    return
  }

  if (oktaCheck && tokenCheck) {
    if (errorMessage !== null && errorMessage == 'User is marked as do not contact') {
      rootStore.logout({ $router: window.vueRouter, path: 'bp/under-review', afterLoginRedirect: true })
    } else if(!is401RouteApproved) {
      rootStore.logout({ path: route.path })
    }
    return
  }
}

export default defineNuxtPlugin (({ $axios, $pinia, $lendioCookies }) => {
  $pinia.use(() => ({ $axios }))

  let thisConfig = null
  const userStore = useUserStore($pinia)
  const rootStore = useRootStore($pinia)
  const route = useRoute()
  let inProgress401 = false

  $axios.interceptors.request.use((config) => {
    const Authorization = userStore.getAuthHeader({ type: 'BEARER', useUnauthorizedToken: true, silent: false })

    if (Authorization) {
      config.headers['Authorization'] = Authorization
    }

    thisConfig = config
    return config
  })

  $axios.interceptors.response.use((response) => {
    return response
  }, error => {
    if (env('environment') != 'LIVE') {
      console.log('AXIOS error on', get(error, 'response.request.path'), error.stack)
    }
    const status = get(error, 'response.status')
    const is401 = status === 401

    const shouldHandle401 = process.client && is401
    if (!shouldHandle401) {
      return Promise.reject(error)
    }

    // only need to handle the first 401
    if (inProgress401) {
      return
    }
    inProgress401 = true

    return handle401({
      config: thisConfig,
      cookies: $lendioCookies,
      error,
      userStore,
      rootStore,
      route
    })
  })
})

